import { useState } from 'react';
import { Mail, MessageCircle } from 'lucide-react';
import Section from './ui/Section.jsx';
import Button from './ui/Button.jsx';
import Reveal from './ui/Reveal.jsx';
import { practice } from '../data/practice.js';

export default function ContactCTA() {
  const [sent, setSent] = useState(false);

  return (
    <Section id="contact" tone="ink" label="06 Contact">
      <div
        className="section-grid-2"
        style={{
          display: 'grid',
          gridTemplateColumns: '1.05fr 0.95fr',
          gap: 80,
          alignItems: 'center',
        }}
      >
        <Reveal>
          <div
            style={{
              fontFamily: 'var(--font-body)',
              fontSize: 11,
              fontWeight: 500,
              letterSpacing: '0.14em',
              textTransform: 'uppercase',
              color: 'var(--blue)',
            }}
          >
            Contact
          </div>
          <h2
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 400,
              fontSize: 'clamp(36px, 4.2vw, 60px)',
              lineHeight: 1.08,
              letterSpacing: '-0.01em',
              color: 'var(--cream)',
              margin: '14px 0 24px',
              maxWidth: '14ch',
            }}
          >
            Wil je een afspraak of <span style={{ fontStyle: 'italic' }}>meer informatie?</span>
          </h2>
          <p
            style={{
              fontFamily: 'var(--font-body)',
              fontSize: 17,
              lineHeight: 1.7,
              color: 'rgba(246,241,234,0.78)',
              maxWidth: '48ch',
              margin: 0,
            }}
          >
            Mail of stuur een bericht via WhatsApp. Dan neem ik zo spoedig mogelijk contact met
            je op.
          </p>

          <div className="contact-actions" style={{ display: 'flex', gap: 12, marginTop: 32 }}>
            <Button
              variant="onDark"
              href={`mailto:${practice.email}`}
              icon={<Mail size={16} strokeWidth={1.5} />}
            >
              {practice.email}
            </Button>
            <Button
              variant="onDarkOutline"
              href={practice.whatsappUrl}
              icon={<MessageCircle size={16} strokeWidth={1.5} />}
            >
              WhatsApp
            </Button>
          </div>
        </Reveal>

        <Reveal
          delay={140}
          as="form"
          className="contact-form"
          onSubmit={(e) => {
            e.preventDefault();
            setSent(true);
          }}
          style={{
            background: 'rgba(246,241,234,0.06)',
            boxShadow: 'inset 0 0 0 1px rgba(246,241,234,0.14)',
            borderRadius: 'var(--radius-md)',
            padding: 28,
            display: 'flex',
            flexDirection: 'column',
            gap: 14,
          }}
        >
          <Field label="Naam" placeholder="Voornaam Achternaam" disabled={sent} />
          <Field label="E-mailadres" type="email" placeholder="jouw@email.nl" disabled={sent} />
          <Field label="Je vraag" placeholder="Waar kan ik je mee helpen?" textarea disabled={sent} />
          <Button
            type="submit"
            variant="onDark"
            style={{ marginTop: 4, alignSelf: 'flex-start' }}
          >
            {sent ? '✓ Verzonden — ik neem contact op' : 'Verstuur'}
          </Button>
        </Reveal>
      </div>
    </Section>
  );
}

function Field({ label, placeholder, type = 'text', textarea = false, disabled = false }) {
  const inputStyle = {
    fontFamily: 'var(--font-body)',
    fontSize: 15,
    color: 'var(--cream)',
    background: 'transparent',
    border: 'none',
    boxShadow: 'inset 0 0 0 1px rgba(246,241,234,0.18)',
    borderRadius: 'var(--radius-sm)',
    padding: '12px 14px',
    outline: 'none',
    width: '100%',
    resize: textarea ? 'vertical' : 'none',
    minHeight: textarea ? 88 : undefined,
  };
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <span
        style={{
          fontFamily: 'var(--font-body)',
          fontSize: 12,
          fontWeight: 500,
          letterSpacing: '0.08em',
          textTransform: 'uppercase',
          color: 'rgba(246,241,234,0.7)',
        }}
      >
        {label}
      </span>
      {textarea ? (
        <textarea placeholder={placeholder} disabled={disabled} style={inputStyle} />
      ) : (
        <input type={type} placeholder={placeholder} disabled={disabled} style={inputStyle} />
      )}
    </label>
  );
}
